import React, { useEffect, useRef, useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Image, Card, Space } from "antd";
import UIFormButton from "@/components/ui/forms/UIFormButton";
import { getImageTemplates } from "@/pages/api/Employer/Employer";

const arrowButtonStyle = (position) => ({
  position: "absolute",
  top: "42%",
  [position]: -10,
  transform: "translateY(-50%)",
  zIndex: 2,
  width: 36,
  height: 36,
  borderRadius: "50%",
  boxShadow: "0 2px 8px rgba(0,0,0,.15)",
  border: "none",
});

const ImageTag = ({ index, image = "" }) => {
  return (
    <Image
      src={`/images/${image}`}
      alt={`Template ${index + 1}`}
      preview={false}
      height={160}
      width="100%"
      style={{ objectFit: "cover", borderRadius: 8 }}
    />
  );
}

const GetTemplates = ({ selectedTemplate, setSelectedTemplate, defaultSelectedId = null, onLoad = null }) => {
  const [TemplateImages, setTemplateImages] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    GetTemplatesApi();
  }, []);

  const GetTemplatesApi = async () => {
    try {
      if (onLoad) { onLoad(defaultSelectedId) }
      const response = (await getImageTemplates()) ?? {};
      const { Status = null, Data = [] } = response;
      if (Status === 1) {
        setTemplateImages(Array.isArray(Data) ? Data : []);
      } else {
        setTemplateImages([]);
      }
    } catch (err) {
      setTemplateImages([]);
      console.error("Error fetching templates:", err);
    }
  };

  if (!TemplateImages.length) return null;

  return (
    <Card bordered={false} style={{ position: "relative", marginBottom: 12, boxShadow: "none", minHeight: "32vh" }}>
      {
        TemplateImages.length >= 2 &&
        <>
          <UIFormButton type="default" style={arrowButtonStyle("left")} onClick={() => scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" })}> <LeftOutlined /> </UIFormButton>
          <UIFormButton type="default" style={arrowButtonStyle("right")} onClick={() => scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" })}> <RightOutlined /> </UIFormButton>
        </>
      }

      <Space
        ref={scrollRef}
        size={16}
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "12px 40px",
          scrollBehavior: "smooth",
        }}
      >
        {TemplateImages.map((item, index) => {
          const isSelected = selectedTemplate == item.TemplateId;
          return (
            <Card
              key={index}
              hoverable
              onClick={() => {
                const nextValue =
                selectedTemplate == item.TemplateId ? 0 : item.TemplateId;
                setSelectedTemplate(nextValue);
              }}
              style={{
                minWidth: 220,
                padding: 4,
                borderRadius: 12,
                cursor: "pointer",
                border: isSelected
                  ? "3px solid rgb(86 142 195)"
                  : "2px solid #e5e7eb",
                boxShadow: isSelected
                  ? "0 0 0 2px rgba(22,119,255,.15)"
                  : "none",
                transform: isSelected ? "scale(1.03)" : "scale(1)",
                transition: "all .25s ease",
              }}
              bodyStyle={{ padding: 0 }}
            >
              {<ImageTag index={index} image={item.FullTemplateName} />}
            </Card>
          );
        })}
      </Space>
    </Card>
  );
};

export default GetTemplates;
